import React from 'react'
import Card from '../card/Card'
import PersonalForm from './PersonalForm'

const Personal = () => {
  return (
    <Card component={<PersonalForm />} title={"Ingrese Personal"} />
  )
}

export default Personal